export default function ProductCTA() {
    return (
      <section className="product-cta">
  
        <div className="cta-content">
  
          <span className="cta-tag">
            GET IN TOUCH
          </span>
  
          <h2>Looking for the Right Paper Solution?</h2>
  
          <p>
            Whether you need premium printing paper, packaging boards,
            kraft paper or a custom sourcing solution, our experts are
            ready to help. Contact us today to discuss your requirements
            and receive a tailored quotation.
          </p>
  
          <div className="cta-buttons">
  
            <a href="/contact" className="cta-btn-primary">
              Contact Us
            </a>
  
          </div>
  
        </div>
  
      </section>
    );
  }